// Ubicación en el repo: src/lib/dayGridLayout.js
// Geometría de la vista día de Agenda — replica fielmente
// buildDaySlots/computeOverlapColumns de prototipo-actual.html (líneas
// ~1117-1214), no una reinterpretación propia. Horario base 09:00-17:45
// en bloques de 15 min, pero el rango se estira solo si hay una cita más
// temprano o más tarde ese día.
export const WORK_START = '09:00';
export const WORK_END = '17:45';
export const SLOT_MIN = 15;
export const ROW_H = 30; // px por bloque de SLOT_MIN, igual que CAL_ROW_H del prototipo

export function timeToMinutes(time) {
  const [h, m] = time.split(':').map(Number);
  return h * 60 + m;
}

export function minutesToTime(minutes) {
  const h = String(Math.floor(minutes / 60)).padStart(2, '0');
  const m = String(minutes % 60).padStart(2, '0');
  return `${h}:${m}`;
}

// Igual que buildDaySlots(dayApts) del prototipo: arranca en WORK_START/
// WORK_END, pero se estira si alguna cita del día cae antes o después.
export function buildDaySlots(dayApts) {
  let startMin = timeToMinutes(WORK_START);
  let endMin = timeToMinutes(WORK_END) + SLOT_MIN;
  dayApts.forEach((a) => {
    const s = timeToMinutes(a.time);
    const e = s + (a.duration || 30);
    if (s < startMin) startMin = Math.floor(s / SLOT_MIN) * SLOT_MIN;
    if (e > endMin) endMin = Math.ceil(e / SLOT_MIN) * SLOT_MIN;
  });
  const slots = [];
  for (let m = startMin; m < endMin; m += SLOT_MIN) slots.push(m);
  return { slots, startMin, endMin };
}

export function minutesToTop(minutes, startMin) {
  return ((minutes - startMin) / SLOT_MIN) * ROW_H + 1;
}

// Igual que el cálculo de `height` del prototipo: nunca más chico que un
// mínimo visible, para que una cita de 15 min no quede ilegible.
export function blockHeight(duration, isBlock) {
  return Math.max((duration / SLOT_MIN) * ROW_H - 3, isBlock ? 22 : ROW_H - 2);
}

// Agrupa en "clusters" de citas mutuamente superpuestas y les asigna
// columna dentro de su cluster — mismo algoritmo que
// computeOverlapColumns() del prototipo.
export function computeOverlapColumns(appointments) {
  const items = appointments
    .map((a) => {
      const start = timeToMinutes(a.time);
      const duration = a.duration || 30;
      return { appt: a, start, end: start + duration, col: 0 };
    })
    .sort((x, y) => x.start - y.start || x.end - y.end);

  let active = [];
  let cluster = [];
  const clusters = [];

  items.forEach((it) => {
    active = active.filter((x) => x.end > it.start);
    if (active.length === 0 && cluster.length > 0) {
      clusters.push(cluster);
      cluster = [];
    }
    const used = new Set(active.map((x) => x.col));
    let col = 0;
    while (used.has(col)) col++;
    it.col = col;
    active.push(it);
    cluster.push(it);
  });
  if (cluster.length) clusters.push(cluster);

  const result = new Map();
  clusters.forEach((cl) => {
    const maxCols = Math.max(...cl.map((x) => x.col)) + 1;
    cl.forEach((x) => result.set(x.appt.id, { col: x.col, cols: maxCols }));
  });
  return result;
}
